<template>
  <div class="navbar-custom" v-show="!hideTop">

    <ul class="list-unstyled topbar-right-menu float-right mb-0">
      <li v-if="$store.state.user">
        <a class="nav-link nav-user mr-0">
          <span>{{$store.state.user.name}}</span>
        </a>
        <a class="nav-link mr-0" @click="logout" id="logout">
          <i class="mdi mdi-logout-variant"></i>
          <span>Välju</span>
        </a>
      </li>
    </ul>

    <div class="app-search">
      <ClientSearch/>
    </div>
    <button class="button-menu-mobile open-left disable-btn">
      <i class="mdi mdi-menu"></i>
    </button>
  </div>
</template>

<script>
  import ClientSearch from './ClientSearch'
  import store from './../services/store'

  export default {
    components: {ClientSearch},
    data() {
      return {
        hideTop: false
      }
    },
    methods: {
      logout() {
        this.$gateway.get('/authentication/logout').then(() => {
          store.dispatch('logout')
          this.$router.push('/login')
        })
      }
    },
    watch: {
      '$route'() {
        this.hideTop = !!this.$router.currentRoute.meta.hideTopBar
      }
    },
  }
</script>
